import { Inject, Injectable, InjectionToken } from '@angular/core';

export const SHOW_LANGUAGE_PICKER = new InjectionToken<boolean>(
  'SHOW_LANGUAGE_PICKER'
);
export const LANGUAGE_PICKER_HAS_TRANSLATIONS = new InjectionToken<boolean>(
  'LANGUAGE_PICKER_HAS_TRANSLATIONS'
);

@Injectable({
  providedIn: 'root',
})
export class LanguageSelectorService {
  constructor(
    @Inject(SHOW_LANGUAGE_PICKER) private showLanguagePicker: boolean,
    @Inject(LANGUAGE_PICKER_HAS_TRANSLATIONS)
    private languagePickerHasTranslations: boolean
  ) {}

  getShowLanguagePicker() {
    return this.showLanguagePicker;
  }

  getLanguagePickerHasTranslations() {
    return this.languagePickerHasTranslations;
  }
}
